import {
  useMutation,
  UseMutationResult,
  useQueryClient,
} from '@tanstack/react-query';

import { parseApiError } from '@cast/api-client';
import { notify } from '@cast/design-system';
import { apiClient } from '@cast/infrastructure-api';
import { Cluster, ClusterDisconnectParams, ClusterResponse } from '@cast/types';

import { getClustersCacheUpdaterFn, enhanceCluster } from 'utils/api-utils';

import {
  EXTERNAL_CLUSTERS_QUERY_KEY,
  getClusterQueryKey,
} from '@cast/shared-cluster-context-data-access';

export const useDisconnectClusterMutation = (
  clusterId: string
): UseMutationResult<Cluster, unknown, ClusterDisconnectParams, unknown> => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (config) => {
      return await apiClient.clusters
        .disconnectCluster({ clusterId, config })
        .then(({ data }) => enhanceCluster(data as ClusterResponse));
    },
    onSuccess: (cluster) => {
      queryClient.setQueryData(getClusterQueryKey({ id: cluster.id }), cluster);

      // Update all matching cluster-list caches using predicate approach
      queryClient.setQueriesData(
        {
          predicate: (query) =>
            query.queryKey[0] === EXTERNAL_CLUSTERS_QUERY_KEY &&
            Array.isArray(query.state.data),
        },
        getClustersCacheUpdaterFn(cluster)
      );
    },
    onError: (error) => {
      notify.error(parseApiError(error));
    },
  });
};
